import { request } from '@pb/utils'

export const fetchReviewItemsNumber = async (userId, isRateReviewEnabled): Promise<void> => {
  let endpoint = 'reviews/rrs/unreviewed'

  if (isRateReviewEnabled) {
    endpoint =
      process.env.BRAND_PREFIX === 'monki' && window.app?.options?.turnTo?.unreviewedPurchases
    const { data } = await request.get(`${endpoint}?userId=${userId}&sort=orderDate%3Adesc`, {
      use: {
        apiVersion: false,
        locale: false,
      },
    })
    return data
  }

  const { data } = await request.get(`${endpoint}?userId=${userId}&sort=orderDate%3Adesc`, {
    use: {
      apiVersion: false,
    },
  })

  return data
}

export const fetchUserMenu = async (): Promise<any> => {
  const { data } = await request.get(`hmmenu/_jcr_content/componentproperties/prop.1.json`, {
    use: {
      apiVersion: false,
    },
  })
  return data
}
